export const DEFAULT_DECIMALS = 18;
//# sourceMappingURL=decimals.js.map